import { ApolloProvider } from '@apollo/client';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import type { ReactElement } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EventBus } from 'src/utils/eventBus';

import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ruRU } from '@mui/x-date-pickers/locales';

import { TOAST_AUTO_CLOSE } from '@constants/timers';

import { apolloClient } from '@system/apolloClient';
import { router } from '@system/routing';
import { ThemeProvider } from '@system/theme';
import '@system/theme/font/fontFSRailway.css';
import '@system/theme/font/fontRussianRailGPro.css';
import '@system/yup';

dayjs.locale('ru');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

function App(): ReactElement {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="ru"
      localeText={
        ruRU.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <ThemeProvider>
        <EventBus />
        <ToastContainer autoClose={TOAST_AUTO_CLOSE} />
        <CssBaseline />

        <ApolloProvider client={apolloClient}>
          <RouterProvider router={router} />
        </ApolloProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
